import * as React from "react";
import Box from "@mui/material/Box";
import WebAssetSharpIcon from "@mui/icons-material/WebAssetSharp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import styled from "styled-components";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Paper,
  Toolbar,
  Tooltip,
  Typography,
  Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import secureLocalStorage from "react-secure-storage";

import "./header.css";
import { updateUser } from "../actions/user";
import toast from "react-hot-toast";
import Logo from "./Logo";
import ProfileImage from "./Avatar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};
export default function SideBar() {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const [ModalOpen, setModalOpen] = React.useState(false);
  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logout = () => {
    let loggingOutId;
    loggingOutId = toast.loading("Please wait we logging you out");
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      dispatch({ type: "LOGOUT" });
      navigate("/claim/login");
      toast.remove(loggingOutId);
    }, 2000);
  };
  let allowApproval = false;
  if (
    user?.results?.e_claim === "Administrator" ||
    user?.results?.e_claim === "Approver"
  ) {
    allowApproval = true;
  } else {
    allowApproval = false;
  }
  const list = allowApproval
    ? [
        {
          text: "Dashboard",
          to: "/claim/",
          icon: <HomeIcon />,
        },
        {
          text: "Departments",
          to: "/claim/department",
          icon: <WebAssetSharpIcon />,
        },
        {
          text: "Categories",
          to: "/claim/category",
          icon: <WebAssetSharpIcon />,
        },

        {
          text: "Report",
          to: "/claim/report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Approvals",
          to: "/claim/approval",
          icon: <CheckIcon />,
        },

        {
          text: "Claim Info",
          to: "/claim/claim-details",
          icon: <AssessmentIcon />,
        },
        {
          text: "Settings",
          to: "/claim/user-page",
          icon: <SettingsIcon />,
        },
      ]
    : [
        {
          text: "Dashboard",
          to: "/claim/",
          icon: <HomeIcon />,
        },

        {
          text: "Settings",
          to: "/claim/user-page",
          icon: <SettingsIcon />,
        },
      ];
  const location = useLocation();
  const path = location.pathname;
  const StyleSidebar = styled.aside`
    overflow: auto;
    grid-row: 1/-1;
    gap: 3.2rem;
  `;
  return (
    <StyleSidebar>
      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={style}
          style={{ backgroundColor: "#dfdfdf" }}
          className='animate__animated animate__pulse'>
          <Typography id='modal-modal-title' variant='h6' component='h2'>
            Logout Confirmation
          </Typography>
          <Typography style={{ marginTop: "10px", fontWeight: "bold" }}>
            {user?.results?.firstName + " " + user?.results?.lastName}
          </Typography>
          <Typography
            id='modal-modal-description'
            sx={{ mt: 2, marginBottom: "20px" }}>
            Are You Sure You Want To Exit?
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
            <Button
              style={{ backgroundColor: "#303846" }}
              onClick={logout}
              size='small'
              variant='contained'>
              Yes <CheckIcon />
            </Button>
            <Button
              color='error'
              className='btn-danger'
              size='small'
              onClick={handleClose}
              variant='contained'>
              CANCEL <CancelIcon />
            </Button>
          </div>
        </Box>
      </Modal>

      <Drawer
        className='drawer-asset'
        component={Paper}
        elevation={0}
        sx={{
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            backgroundColor: "#2C3E50",
            boxShadow: "30px",
            color: "#fff",
            width: "13rem",
            height: "100vh",
            boxSizing: "border-box",
            border: "none",
            marginRight: "10px",
          },
        }}
        variant='permanent'
        anchor='left'>
        <Toolbar
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#3E5871",
            columnGap: "5px",
            padding: "5px",
            marginTop: "60px",
          }}>
          <ProfileImage />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}>
            <Typography style={{ fontSize: "11px", color: "#ccc" }}>
              {user?.results.firstName} {user?.results.lastName}
            </Typography>
            <Typography style={{ fontSize: "10px", color: "#ccc" }}>
              Role: {user?.results.userRole}
            </Typography>
            <Typography style={{ fontSize: "10px", color: "#ccc" }}>
              Branch: {user?.results.branch}
            </Typography>
          </div>
        </Toolbar>

        <span
          style={{ marginLeft: "10px", marginTop: "10px", color: "#1abc9c" }}>
          Navigation
        </span>
        <List>
          {list.map((text) => (
            <ListItem
              className={path === text.to ? "selected-item" : "unselected-item"}
              key={text.text}
              disablePadding>
              <ListItemButton onClick={() => navigate(text.to)}>
                <ListItemIcon
                  style={{
                    color: path === text.to ? "#ffffff" : "#ffffff",
                  }}>
                  {text.icon}
                </ListItemIcon>
                <ListItemText
                  style={{ marginLeft: "-20px", fontSize: "12px" }}
                  onClick={() => navigate(text.to)}>
                  <Typography style={{ fontSize: "12px" }}>
                    {text.text}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}

          <ListItem
            disablePadding
            className={
              path === "/claim/imprest" ? "selected-item" : "unselected-item"
            }>
            <ListItemButton onClick={() => navigate("/claim/imprest")}>
              <ListItemIcon
                style={{
                  color: path === "/claim/imprest" ? "#ffffff" : "#ffffff",
                }}>
                <AssessmentIcon />
              </ListItemIcon>
              <ListItemText style={{ marginLeft: "-20px", fontSize: "12px" }}>
                <Typography style={{ fontSize: "14px" }}>
                  Utilise Imprest
                </Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>

        <div
          style={{
            margin: "10px",
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center",
            paddingBottom: "50px",
          }}>
          <Tooltip title='click to logout'>
            <IconButton
              style={{ backgroundColor: "#1abc9c " }}
              onClick={handleOpen}>
              <LogoutIcon style={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        </div>

        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "13rem",
            height: "30px",
            backgroundColor: "#425262",
          }}>
          <em>Powered By </em>
          <Logo />
        </div>
      </Drawer>
    </StyleSidebar>
  );
}
